import React from 'react';

const Title = ({children}) => {
    return (
        <p className="text-center uppercase text-xl font-bold tablet:mb-6 tracking-wider mb-4 text-primary">
            { children }
        </p>
    );
}

export default Title;
